/* eslint-disable react/prop-types */
import React from 'react';
import ParticipationRate from '../ParticipationRate';

/**
 * Conversion correlation (026 US6) on the shared au-panel system. Pause
 * participation by subscription state (Paid / Trial / Free). Reuses
 * ParticipationRate so the "<n> of <total> users (<pct>%)" rendering matches every
 * other rate on the page. Text only; tabular numerals.
 *
 * Props: { data } — [{ plan, paused_users, plan_users, share_pct }]
 */
const PausePlanCorrelation = ({ data = [] }) => (
  <div data-testid="pause-plan-correlation">
    <h3 className="au-seg-title">Does pausing drive conversion?</h3>
    <div className="au-panel">
      {Array.isArray(data) && data.length ? (
        <ul className="pause-rows">
          {data.map((r) => (
            <li key={r.plan}>
              <span className="pause-rows__label">{r.plan}</span>
              <span className="pause-rows__val">
                <ParticipationRate count={r.paused_users} total={r.plan_users} /> paused
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <div className="au-chart-empty">No subscription data in this range.</div>
      )}
    </div>
  </div>
);

export default PausePlanCorrelation;
